// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editMemberFormWrap{box-sizing:border-box;width:100%;position:relative;padding:60px .5rem 0 .5rem;background:#f0ebf8;overflow:auto}", ""]);
// Exports
module.exports = exports;
